"use client";

import { useEffect } from "react";

export default function AdUnit({
  slot,
  style,
  layout,
  format,
  className = "",
}) {
  useEffect(() => {
    try {
      if (typeof window !== "undefined") {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error("Adsense Error:", err);
    }
  }, []);

  return (
    <ins
      className={`adsbygoogle ${className}`}
      style={style}
      data-ad-client="ca-pub-2721952018319694"
      data-ad-slot={slot}
      {...(layout ? { "data-ad-layout": layout } : {})}
      {...(format ? { "data-ad-format": format } : {})}
    />
  );
}
